import { makeRequest } from "../http-common";

const DeletedItemsDataService = {

  async getDeletedAspectRelationships() {
    return makeRequest("get", "/aspect/relationships/deleted");
  },

  async getDeletedPolicyRelationships() {
    return makeRequest("get", "/policy/relationships/deleted");
  },

  async getDeletedNotes() {
    return makeRequest("get", "/note/deleted/list");
  },

  async restoreAspectRelationship(id) {
    return makeRequest("patch", `/aspect/relationship/${id}/restore`);
  },

  async restorePolicyRelationship(id) {
    return makeRequest("patch", `/policy/relationship/${id}/restore`);
  },

  async restoreNote(id) {
    return makeRequest("patch", `/note/${id}/restore`);
  },

};

export default DeletedItemsDataService;
